(function () {
  function setup(button) {
    var sectionId = button.dataset.section;
    if (!sectionId) return;

    var form = document.getElementById('ProductForm-' + sectionId);
    if (!form) return;

    var atcButton = form.querySelector('[data-ck-sold-out-atc]');
    var modal = document.getElementById('CkSoldOutModal-' + sectionId);
    var variantIdInput = modal ? modal.querySelector('[data-ck-sold-out-variant-id]') : null;
    var titleEl = modal ? modal.querySelector('[data-ck-sold-out-title]') : null;
    var titleTemplate = titleEl ? titleEl.dataset.ckSoldOutTitleTemplate : null;

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var soldOut = variant.available === false;

      button.hidden = !soldOut;

      if (atcButton) {
        atcButton.hidden = soldOut;
        atcButton.disabled = soldOut;
      }

      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      if (titleEl && titleTemplate) {
        titleEl.innerHTML = titleTemplate.split('{variant}').join(variant.title);
      }
    });
  }

  document.querySelectorAll('[data-ck-sold-out-button]').forEach(setup);

  function showResult(modal, text) {
    if (!modal) return;
    var forms = modal.querySelector('[data-ck-sold-out-forms]');
    var result = modal.querySelector('[data-ck-sold-out-result]');
    var resultText = modal.querySelector('[data-ck-sold-out-result-text]');
    var errorEl = modal.querySelector('[data-ck-sold-out-error]');

    if (errorEl) errorEl.hidden = true;
    if (resultText) resultText.textContent = text;
    if (result) result.hidden = false;
    if (forms) forms.hidden = true;
  }

  function showError(modal, text) {
    if (!modal) return;
    var errorEl = modal.querySelector('[data-ck-sold-out-error]');
    if (!errorEl) return;
    errorEl.textContent = text;
    errorEl.hidden = false;
  }

  function setupForm(form) {
    var modal = form.closest('.ck-sold-out-modal');
    var submitButton = form.querySelector('[data-ck-sold-out-submit]');
    var submitLabel = submitButton ? submitButton.querySelector('[data-ck-sold-out-submit-label]') : null;
    var emailInput = form.querySelector('input[name="email"]');
    var variantIdInput = form.querySelector('[data-ck-sold-out-variant-id]');
    var companyId = form.dataset.klaviyoCompanyId;
    var defaultSubmitText = submitLabel ? submitLabel.textContent : '';

    function setLoading(isLoading) {
      if (submitButton) submitButton.disabled = isLoading;
      if (submitLabel) {
        submitLabel.textContent = isLoading ? form.dataset.sendingText : defaultSubmitText;
      }
    }

    function subscribeEmail(email, variantId) {
      return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      }).then(function (response) {
        if (response.status !== 202) {
          throw new Error('Klaviyo back-in-stock subscription failed with status ' + response.status);
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!form.reportValidity()) return;
      if (!emailInput || !variantIdInput || !variantIdInput.value) return;

      setLoading(true);

      subscribeEmail(emailInput.value.trim(), variantIdInput.value)
        .then(function () {
          showResult(modal, form.dataset.successText);
        })
        .catch(function (error) {
          console.error(error);
          showError(modal, form.dataset.errorText);
        })
        .finally(function () {
          setLoading(false);
        });
    });
  }

  document.querySelectorAll('[data-ck-sold-out-form]').forEach(setupForm);

  function waitForElement(selector, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector(selector);
      if (existing) {
        resolve(existing);
        return;
      }

      var observer = new MutationObserver(function () {
        var el = document.querySelector(selector);
        if (el) {
          observer.disconnect();
          resolve(el);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(function () {
        observer.disconnect();
        reject(new Error('Timed out waiting for ' + selector));
      }, timeoutMs || 5000);
    });
  }

  function findChatarminTrigger() {
    return document.querySelector('#chatarmin-backinstock-button-below-pay button')
      || document.querySelector('[id^="chatarmin-backinstock-button"] button');
  }

  function setupChatarminConsentGuard(slot) {
    var modal = slot.closest('.ck-sold-out-modal');
    if (!modal) return;

    var consentCheckbox = modal.querySelector('[data-ck-sold-out-consent]');

    slot.addEventListener('click', function (event) {
      if (!consentCheckbox || consentCheckbox.checked) return;
      var submitButton = event.target.closest('button[type="submit"]');
      if (!submitButton) return;

      event.preventDefault();
      event.stopPropagation();
      consentCheckbox.reportValidity();
    }, true);
  }

  document.querySelectorAll('[data-ck-chatarmin-slot]').forEach(setupChatarminConsentGuard);

  function watchForChatarminSuccess(abandonedCard, modal, field) {
    var successText = field ? field.dataset.whatsappSuccessText : '';

    setTimeout(function () {
      var observer = new MutationObserver(function () {
        observer.disconnect();
        showResult(modal, successText);
      });
      observer.observe(abandonedCard, { childList: true, subtree: true });
    }, 500);
  }

  function removeFormDivider(modal) {
    var form = modal.querySelector('.ck-sold-out-modal__form');
    if (!form) return;
    form.classList.remove('ck-sold-out-divider--mobile', 'ck-sold-out-divider--desktop');
  }

  function loadChatarminForm(slot) {
    var modal = slot.closest('.ck-sold-out-modal');
    var field = slot.closest('.ck-sold-out-modal__field--chatarmin');
    var trigger = findChatarminTrigger();

    if (!trigger) {
      console.warn('CK | Sold Out: Chatarmin trigger button not found — is the Chatarmin app enabled for this page/language?');
      if (field) field.hidden = true;
      removeFormDivider(modal);
      return Promise.resolve();
    }

    trigger.click();

    return waitForElement('.wa-space-y-5.wa-p-6', 5000)
      .then(function (chatarminContent) {
        var abandonedCard = chatarminContent.closest('.wa-bg-white.wa-rounded-lg.wa-max-w-lg.wa-w-full.wa-mx-4.wa-relative');

        slot.innerHTML = '';
        slot.appendChild(chatarminContent);
        slot.hidden = false;
        if (field) field.hidden = false;

        if (abandonedCard) {
          watchForChatarminSuccess(abandonedCard, modal, field);
        }
      })
      .catch(function (error) {
        console.warn('CK | Sold Out: could not load Chatarmin WhatsApp form.', error);
        if (field) field.hidden = true;
        removeFormDivider(modal);
      });
  }

  function setupModalReveal(modal) {
    var loading = modal.querySelector('[data-ck-sold-out-loading]');
    var body = modal.querySelector('[data-ck-sold-out-body]');
    var slot = modal.querySelector('[data-ck-chatarmin-slot]');

    modal.addEventListener('modal:afterShow', function () {
      if (loading) loading.hidden = false;
      if (body) body.hidden = true;

      var ready = slot ? loadChatarminForm(slot) : Promise.resolve();

      ready.then(function () {
        if (loading) loading.hidden = true;
        if (body) body.hidden = false;
      });
    });
  }

  document.querySelectorAll('.ck-sold-out-modal').forEach(setupModalReveal);
})();
